import { ConnectionDetailInfo, isSameConnectionDetailInfo } from '~src/datasource/dataConnection/models/ConnectionDetailInfo';

import { FlowBasicInfo } from '../../../flow/models/FlowInfo';
import { IContentInfo } from '../../../spacesPlatform/models/IContentInfo';
import { IDataSourceBasicInfo } from '../../models/IDataSourceInfo';

export interface IDataConnectionInfoProperties {
  connectionType: string;
  connectionTypeDisplayName: string;

  connectionDetails: ConnectionDetailInfo; // The specific subtype of this object depends on the connectionDetails.type

  connectionTypeEditable: boolean;
  connectionOAuth: boolean;
  testingConnectionAllowed: boolean;
  usingRemoteQueryAgent: boolean;
}

export interface IDataConnectionInfo extends
  IDataConnectionInfoProperties,
  IContentInfo
{
  datasource?: IDataSourceBasicInfo;
  flow?: FlowBasicInfo;
}

export const isSameDataConnectionInfoProperties = (left: IDataConnectionInfoProperties) => (right: IDataConnectionInfoProperties) =>
  isSameConnectionDetailInfo(left.connectionDetails)(right.connectionDetails);
